// extracted by mini-css-extract-plugin
export default {"btn_style":"styles_btn_style__k7aSv"};